import { createReducer, on } from '@ngrx/store';
import * as NavActions from '../actions/nav.action';
import { MenuTheme } from 'src/app/shared/models';

export interface NavState {
  menuOpen: boolean;
  theme: MenuTheme;
}

export const initialState: NavState = {
  menuOpen: false,
  theme: 'light',
};

export const NavReducer = createReducer(
  initialState,
  on(NavActions.OpenMenu, state => {
    return {
      ...state,
      menuOpen: true,
    };
  }),
  on(NavActions.CloseMenu, state => {
    return {
      ...state,
      menuOpen: false,
    };
  }),
  on(NavActions.ToggleMenu, state => {
    return {
      ...state,
      menuOpen: !state.menuOpen,
    };
  }),
  on(NavActions.SetMenuTheme, (state, theme) => {
    return {
      ...state,
      theme: theme.theme,
    };
  }),
  on(NavActions.ResetMenuTheme, state => {
    return {
      ...state,
      theme: initialState.theme,
    };
  })
);

export const getMenuOpen = (state: NavState) => state.menuOpen;
export const getMenuTheme = (state: NavState) => state.theme;
